// extracted by mini-css-extract-plugin
export default {"wrapperSizeButtons":"pEbGra3r","button":"ofqmidua","down":"fFw3Csin","up":"Qmc8Yvdz"};